/* unplugin-vue-components disabled */import { render } from "./PlayerLoading.vue?vue&type=template&id=24963c2c&scoped=true"
import script from "./PlayerLoading.vue?vue&type=script&lang=js"
export * from "./PlayerLoading.vue?vue&type=script&lang=js"

import "./PlayerLoading.vue?vue&type=style&index=0&id=24963c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24963c2c"]])

export default __exports__